import { GroupState } from "src/model/state/partials/checkout.model";
import { Address } from "src/api/address";
import { PriceItxDto } from "src/api/customer";
import { DropPoint } from "src/api/locations";

export const EXPEDITION_SHIPPING_TYPE = {
    DROP2HOME: "DROP2HOME",
    DROPPOINT: "DROPPOINT",
    BOTH: "BOTH"
  } as any
  
export type ExpeditionShippingType = (typeof EXPEDITION_SHIPPING_TYPE)[keyof typeof EXPEDITION_SHIPPING_TYPE];

export interface FinalGroups {
    all: GroupState[],
    international: GroupState[],
    national: GroupState[]
}

export type ShippingMethodString = "DROP2HOME" | "DROPPOINT";

export interface NewExpedition  {
    sellerdId: number;
    shippingTypeSelected: ExpeditionShippingType;
    homeAddressSelected: Address | null,
    dropPointAddressSelected: DropPoint | null,
    selectedDPShippingMethodId: number | null,
    selectedDHShippingMethodId: number | null,
    selectedDHShippingMethodPrice: PriceItxDto | null
    selectedDPShippingMethodPrice: PriceItxDto | null
}

export const ZARA_ADDRESS_URL_PARAMS = {
    returnToStage2: "returnToStage2",
    expeditionId: "expeditionId",
    addressId: "addressId",
    separateOrders: "separateOrders",
    entryOrigin: "origin",
    fromAlert:"fromAlert"
}